module.exports = __webpack_public_path__ + "img/cucumber.be5030ca.webp";